// extracted by mini-css-extract-plugin
export var card_left_wrapper = "related-recipes-module--card_left_wrapper--0d8d5";
export var card_right_wrapper = "related-recipes-module--card_right_wrapper--bb9b5";
export var product_grid_section = "related-recipes-module--product_grid_section--c87a7";
export var triangle_wrapper_left = "related-recipes-module--triangle_wrapper_left--46305";
export var triangle_wrapper_right = "related-recipes-module--triangle_wrapper_right--2de61";